import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type Settings = {
  userTierDisplayMode: 'SILVER_AND_GOLD' | 'GOLD_AS_VERIFIED'
}
export type SettingsState = {
  data?: Settings
  fetching: boolean
  hasError: boolean
}

export const initialState: SettingsState = {
  fetching: false,
  hasError: false
}

const configSlice = createSlice({
  initialState,
  name: 'settings',
  reducers: {
    error(state) {
      state.fetching = false
      state.hasError = true
    },
    fetch(state) {
      state.fetching = true
    },
    set(state, action: PayloadAction<Settings>) {
      state.hasError = false
      state.fetching = false
      state.data = action.payload
    }
  }
})

export const { actions } = configSlice
export default configSlice.reducer
